/**********************************************************
Product View: Displays information about the selected chemical
7/24/19
@params {Object} selectedChemical
**********************************************************/
import { determineIcon } from '../../cult_utils';
import moment from 'moment';
import React from 'react';
const $ = window.$;

const ProductView = ({ selectedChemical, email, onClick }) => {
  if (Object.keys(selectedChemical).length === 0) return <div></div>;
  $(document).ready(function(){
    $('.tooltipped').tooltip({delay: 50});
  });
  let { color, icon } = determineIcon(selectedChemical.type);
  return (
    <div className="product">
      <span className="chem-name">{ selectedChemical.name }</span>
      <span className="right">
        <a href={selectedChemical.url ? selectedChemical.url : 'https://www.greenbook.net'} target="_blank">
          <i className="material-icons product-info-icon tooltipped" data-position="left" data-delay="50" data-tooltip={'More Info'}>info</i>
        </a>
      </span>
      <hr />
      <div className="row">
        <div className="col s12 m12 l12">
          <div className="card">
            <div className="card-display blue">
              <div className="product-title">{ selectedChemical.type }</div>
              <div className="product-recoDosage">
                { selectedChemical.recoDosage.split(' ')[0] === '' ? 'N/A' : <span>{ selectedChemical.recoDosage }</span> }
              </div>
              <div className="product-reco-desc">Recommended Dosage</div>
            </div>
            <div className="card-content product-card-content">
              <ul className="collection product-collection">
                <li className="collection-item avatar">
                  <i className={`material-icons circle ${color} darken-2`}>{ icon }</i>
                  <span className="product-title-info">Product Information</span>
                  <p>{ selectedChemical.manufacturer }</p>
                  <a href="#!" className="secondary-content"><i className="material-icons">grade</i></a>
                </li>
                <li className="collection-item product-item">
                  <div className="row">
                    <div className="col s6 m6 l6">
                      <p className="collections-title">Ingredients</p>
                      <p className="collections-content">{ selectedChemical.ingredients }</p>
                    </div>
                    <div className="col s3 m3 l3"></div>
                    <div className="col s3 m3 l3">
                      <span className="task-cat purple">Components</span>
                    </div>
                  </div>
                </li>
                <li className="collection-item product-item">
                  <div className="row">
                    <div className="col s6 m6 l6">
                      <p className="collections-title">Restricted Entry Interval (REI)</p>
                      <p className="collections-content red-text"><b>{ selectedChemical.rei } days</b></p>
                    </div>
                    <div className="col s3 m3 l3"></div>
                    <div className="col s3 m3 l3">
                      <span className="task-cat cyan">Interval</span>
                    </div>
                  </div>
                </li>
                <li className="collection-item product-item">
                  <div className="row">
                    <div className="col s6 m6 l6">
                      <p className="collections-title">Pre-harvest Interval</p>
                      <p className="collections-content orange-text"><b>{ selectedChemical.preHarvestInterval } days</b></p>
                    </div>
                    <div className="col s3 m3 l3"></div>
                    <div className="col s3 m3 l3">
                      <span className="task-cat cyan">Interval</span>
                    </div>
                  </div>
                </li>
                <li className="collection-item product-item">
                  <div className="row">
                    <div className="col s6 m6 l6">
                      <p className="collections-title">Max Quantity Per Acre/Year</p>
                      <p className="collections-content red-text"><b>{ selectedChemical.maxQuantity }</b></p>
                    </div>
                    <div className="col s3 m3 l3"></div>
                    <div className="col s3 m3 l3">
                      <span className="task-cat red">Max Amount</span>
                    </div>
                  </div>
                </li>
                <li className="collection-item product-item">
                  <div className="row">
                    <div className="col s6 m6 l6">
                      <p className="collections-title">EPA #</p>
                      <p className="collections-content">{ selectedChemical.epaNo }</p>
                    </div>
                    <div className="col s3 m3 l3"></div>
                    <div className="col s3 m3 l3">
                      <span className="task-cat amber">Certified</span>
                    </div>
                  </div>
                </li>
                <li className="collection-item product-item">
                  <div className="row">
                    <div className="col s6 m6 l6">
                      <p className="collections-title">Hawaii Registration</p>
                      <p className="collections-content">{ selectedChemical.hawaiiRegistration ? 'Yes' : 'No' }</p>
                    </div>
                    <div className="col s3 m3 l3"></div>
                    <div className="col s3 m3 l3">
                      <span className={`task-cat ${ selectedChemical.hawaiiRegistration ? 'green' : 'red' } `}>Availability</span>
                    </div>
                  </div>
                </li>
                <li className="collection-item product-item">
                  <div className="row">
                    <div className="col s6 m6 l6">
                      <p className="collections-title">Last Edit</p>
                      <p className="collections-content">{ moment(selectedChemical.dateEdited).format('YYYY-MM-DD hh:mm:ss a') }</p>
                    </div>
                    <div className="col s3 m3 l3"></div>
                    <div className="col s3 m3 l3">
                      <p className="collections-title">Edited by</p>
                      <p className="collections-content">{ selectedChemical.editedByName }</p>
                    </div>
                  </div>
                </li>
              </ul>
              <span className="flow-text">Email files</span><hr />
              <div className="card-footer">
                { selectedChemical.label ?
                    <button onClick={(e) => onClick(e.target.name, email)} name={selectedChemical.label} className="btn waves-light waves-effect product-file-btn">
                      Label</button>
                  : ''
                }
                { selectedChemical.sds ?
                    <button onClick={(e) => onClick(e.target.name, email)} name={selectedChemical.sds} className="btn waves-light waves-effect product-file-btn">
                      Safety Data Sheet</button>
                  : ''
                }
                { selectedChemical.supplementalLabel ?
                    <button onClick={(e) => onClick(e.target.name, email)} name={selectedChemical.supplementalLabel} className="btn waves-light waves-effect product-file-btn">
                      Supplemental Label</button>
                  : ''
                }
                { selectedChemical.specialLocalNeedsLabel ?
                    <button onClick={(e) => onClick(e.target.name, email)} name={selectedChemical.specialLocalNeedsLabel} className="btn waves-light waves-effect product-file-btn">
                      Special Local Needs</button>
                  : ''
                }
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
export default ProductView;



/* END */



// WEBPACK FOOTER //
// ./src/cultivation/components/chemical/product_view.js